import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-dynamic-filter',
  templateUrl: './dynamic-filter.component.html',
  styleUrls: ['./dynamic-filter.component.sass'],
})
export class DynamicFilterComponent implements OnInit {
  @Input() placeholder: string = 'Pesquisar';
  @Input() label: string = 'Pesquisar';
  @Output() search = new EventEmitter<string>();
  @Output() clear = new EventEmitter<void>();
  inputModel: string = '';

  constructor() {}

  ngOnInit(): void {}

  onSearch() {
    this.search.emit(this.inputModel);
  }

  onInput() {
    if (!this.inputModel) {
      this.clear.emit();
    }
  }

  validAlphaNumeric(event: KeyboardEvent) {
    const pattern = /^[a-zA-Z0-9_ ]*$/;
    if (!pattern.test(event.key)) {
      event.preventDefault();
    }
  }
}
